import React from 'react'
import PropTypes from 'prop-types'
import styles from './_footer.css'
import Svg from 'components/util/Svg'
import { FormattedMessage } from 'react-intl'
import Waypoint from 'react-waypoint'
import Confetti from 'react-confetti'
import banner from 'images/year-in-review/2017/y-vs-year-banner.png'

function YearInReviewFooter (props) {
  const {
    isLoggedIn,
    activateStatCard,
    activeCards,
    onTwitterShare,
    onFacebookShare,
    onAdClick,
    userCountry,
    year,
  } = props

  const id = 'footer'
  const isActive = activeCards.includes(id)
  const showSponsor = userCountry === 'US'
  const confettiOptions = {
    width: window.innerWidth,
    height: window.innerHeight,
    numberOfPieces: 500,
    recycle: false,
    colors: ['white'],
    gravity: 0.025,
  }

  return (
    <div className={styles.footerWrapper}>
      <div className={styles.footer}>
        { showSponsor ?
          <div className={styles.footerAdBanner}>
            <a onClick={() => { onAdClick('http://www.mapmyfitness.com/challenges/yvsty2018/') }}>
              <img src={banner} />
            </a>
          </div>
        : null }
        <div className={styles.footerContent}>
          <div className={styles.footerText}>
            <h2 className={styles.footerTagline}>
              <FormattedMessage
                id='yearInReview.2017.footer.tagline'
                defaultMessage={`Thank You\n For A Wonderful \n{ year }`}
                values={ { year } }
              />
              <Waypoint onEnter={ () => { if (!isActive) { activateStatCard(id) } } } />
            </h2>
            <p className={styles.footerDescription}>
              { isLoggedIn ?
                <FormattedMessage
                  id='yearInReview.2017.footer.description.loggedIn'
                  defaultMessage={`Here's to a happy and healthy 2018!\nShare your 2017 accomplishments with your friends and the MapMyFitness Community!`}
                />
                :
                  <FormattedMessage
                    id='yearInReview.2017.footer.description.loggedOut'
                    defaultMessage={`Here's to a happy and healthy 2018!\nSign Up to review your personalized Year in Review or Share these stats about the MapMyFitness Community!`}
                  />
              }
            </p>
          </div>
          {!isLoggedIn ?
            <ul className={styles.authLinks}>
              <li>
                <a href='/auth/login'>
                  <FormattedMessage id='site.nav.login' defaultMessage='Log in' />
                </a>
              </li>
              <li className={styles.accent}>
                <a href='/auth/signup'>
                  <FormattedMessage id='site.nav.signup' defaultMessage='Sign Up' />
                </a>
              </li>
            </ul>
          : null }
        </div>
        <ul className={styles.socialLinks}>
          <li onClick={onFacebookShare}>
            <Svg name='facebook' width={32} height={32} fill='white' />
          </li>
          <li onClick={onTwitterShare}>
            <Svg name='twitter' width={32} height={32} fill='white' />
          </li>
        </ul>
      </div>
      {isActive ?
        <div className={styles.confetti}>
          <Confetti {...confettiOptions} />
        </div>
      : null}
    </div>
  )
}

YearInReviewFooter.propTypes = {
  isLoggedIn: PropTypes.bool,
  activateStatCard: PropTypes.func,
  activeCards: PropTypes.array,
  site: PropTypes.object,
  onTwitterShare: PropTypes.func,
  onFacebookShare: PropTypes.func,
  onAdClick: PropTypes.func,
  userCountry: PropTypes.string,
  year: PropTypes.string,
}

export default YearInReviewFooter



// WEBPACK FOOTER //
// ./src/components/yearInReview/2017/Footer/Footer.jsx